function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.468 25.1653C34.468 26.4534 35.4865 27.4719 36.7745 27.4719C38.0626 27.4719 39.0811 26.4534 39.0811 25.1653V18.8748H47.5882V25.1653C47.5882 26.4534 48.6067 27.4719 49.8948 27.4719C51.1828 27.4719 52.2013 26.4534 52.2013 25.1653V8.45056C52.2013 7.1625 51.1828 6.14404 49.8948 6.14404C48.6067 6.14404 47.5882 7.1625 47.5882 8.45056V14.6213H39.0811V8.45056C39.0811 7.1625 38.0626 6.14404 36.7745 6.14404C35.4865 6.14404 34.468 7.1625 34.468 8.45056V25.1653Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5332 27.2921H71.3054C72.4437 27.2921 73.3723 26.3935 73.3723 25.2552C73.3723 24.1169 72.4437 23.1883 71.3054 23.1883H61.8097V18.785H69.8077C70.946 18.785 71.8746 17.8863 71.8746 16.748C71.8746 15.6098 70.946 14.6812 69.8077 14.6812H61.8097V10.4276H71.1557C72.2939 10.4276 73.2225 9.52893 73.2225 8.39065C73.2225 7.25236 72.2939 6.32377 71.1557 6.32377H59.5332C58.2451 6.32377 57.2267 7.34223 57.2267 8.63029V24.9856C57.2267 26.2737 58.2451 27.2921 59.5332 27.2921Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M75.8562 25.3151C75.8562 26.5133 76.7848 27.4719 77.983 27.4719C78.9416 27.4719 79.7204 26.9327 80.1098 26.034L81.5776 22.5892H90.8037L92.2116 25.8843C92.6309 26.8428 93.3498 27.4719 94.4282 27.4719C95.6563 27.4719 96.6149 26.4834 96.6149 25.2552C96.6149 24.9557 96.525 24.6561 96.3753 24.3266L89.0663 7.82151C88.5571 6.68322 87.6584 5.99426 86.4003 5.99426H86.1307C84.8726 5.99426 83.944 6.68322 83.4348 7.82151L76.1258 24.3266C75.976 24.6561 75.8562 24.9856 75.8562 25.3151ZM83.285 18.5154L86.1906 11.5958L89.0962 18.5154H83.285Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M100.228 24.9856C100.228 26.2737 101.247 27.2921 102.535 27.2921H108.406C114.996 27.2921 119.549 22.7091 119.549 16.808V16.748C119.549 10.8469 114.996 6.32377 108.406 6.32377H102.535C101.247 6.32377 100.228 7.34223 100.228 8.63029V24.9856ZM104.841 23.1284V10.4875H108.406C112.18 10.4875 114.726 13.0936 114.726 16.808V16.8679C114.726 20.5823 112.18 23.1284 108.406 23.1284H104.841Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M130.826 27.5917C135.349 27.5917 138.524 25.2552 138.524 21.0915V21.0316C138.524 17.3771 136.128 15.8494 131.874 14.7411C128.25 13.8125 127.351 13.3631 127.351 11.9852V11.9253C127.351 10.9069 128.28 10.0981 130.047 10.0981C131.485 10.0981 132.923 10.6073 134.45 11.5059C134.81 11.7156 135.169 11.8355 135.619 11.8355C136.817 11.8355 137.775 10.9069 137.775 9.70866C137.775 8.81001 137.266 8.18096 136.757 7.88142C134.87 6.68322 132.653 6.02422 130.107 6.02422C125.823 6.02422 122.768 8.54042 122.768 12.3447V12.4046C122.768 16.5683 125.494 17.7366 129.718 18.8149C133.222 19.7136 133.941 20.3127 133.941 21.4809V21.5408C133.941 22.769 132.803 23.5178 130.916 23.5178C128.879 23.5178 127.141 22.7989 125.554 21.6307C125.254 21.421 124.835 21.2113 124.236 21.2113C123.038 21.2113 122.079 22.1399 122.079 23.3381C122.079 24.057 122.439 24.716 122.948 25.0755C125.284 26.753 128.07 27.5917 130.826 27.5917Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M146.972 25.1653C146.972 26.4534 147.99 27.4719 149.278 27.4719C150.566 27.4719 151.585 26.4534 151.585 25.1653V10.5773H156.018C157.186 10.5773 158.145 9.6188 158.145 8.45056C158.145 7.28232 157.186 6.32377 156.018 6.32377H142.538C141.37 6.32377 140.411 7.28232 140.411 8.45056C140.411 9.6188 141.37 10.5773 142.538 10.5773H146.972V25.1653Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M157.822 25.3151C157.822 26.5133 158.751 27.4719 159.949 27.4719C160.908 27.4719 161.687 26.9327 162.076 26.034L163.544 22.5892H172.77L174.178 25.8843C174.597 26.8428 175.316 27.4719 176.394 27.4719C177.623 27.4719 178.581 26.4834 178.581 25.2552C178.581 24.9557 178.491 24.6561 178.341 24.3266L171.033 7.82151C170.523 6.68322 169.625 5.99426 168.367 5.99426H168.097C166.839 5.99426 165.91 6.68322 165.401 7.82151L158.092 24.3266C157.942 24.6561 157.822 24.9856 157.822 25.3151ZM165.251 18.5154L168.157 11.5958L171.062 18.5154H165.251Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M182.194 25.1653C182.194 26.4534 183.213 27.4719 184.501 27.4719C185.789 27.4719 186.807 26.4534 186.807 25.1653V20.5823H190.492L194.985 26.2737C195.524 26.9626 196.213 27.4719 197.262 27.4719C198.37 27.4719 199.448 26.6331 199.448 25.3451C199.448 24.6262 199.149 24.1469 198.7 23.5777L195.494 19.6836C198.041 18.6352 199.688 16.5983 199.688 13.3032V13.2433C199.688 11.2663 199.059 9.6188 197.891 8.45056C196.513 7.07264 194.446 6.32377 191.78 6.32377H184.501C183.213 6.32377 182.194 7.34223 182.194 8.63029V25.1653ZM186.807 16.5084V10.4875H191.391C193.637 10.4875 195.015 11.5059 195.015 13.483V13.5429C195.015 15.3102 193.727 16.5084 191.48 16.5084H186.807Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M208.724 25.1653C208.724 26.4534 209.743 27.4719 211.031 27.4719C212.319 27.4719 213.337 26.4534 213.337 25.1653V10.5773H217.77C218.939 10.5773 219.897 9.6188 219.897 8.45056C219.897 7.28232 218.939 6.32377 217.77 6.32377H204.291C203.123 6.32377 202.164 7.28232 202.164 8.45056C202.164 9.6188 203.123 10.5773 204.291 10.5773H208.724V25.1653Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  y: 7.32227,
  width: 28.9563,
  height: 4.49322,
  rx: 2.24661,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 7.98798,
  y: 15.3102,
  width: 20.4691,
  height: 4.49322,
  rx: 2.24661,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  y: 22.9653,
  width: 28.9563,
  height: 4.49322,
  rx: 2.24661,
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 30,
    viewBox: "0 0 221 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e91b233f.svg";
export { ForwardRef as ReactComponent };